export default "__VITE_ASSET__Cop4NHy6__"